import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { PORT } from "../../config";
// import logo from '../../assets/img/logo_right-removebg.png';
import "./Login.css";
import { notify } from "react-notify-toast";
// import { LinkedInLoginButton } from "react-social-login-buttons";

import SignupContainer from "../Signup-Login/SignupContainer";
import GoogleDivider from "../Signup-Login/GoogleDivider";
import LinkToCreateAccount from "../Signup-Login/LinkToCreateAccount";
import LinkToTeacherAccount from "../Signup-Login/LinkToTeacherAccount";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import FormField from "../../Components/FormField/FormField";
import PasswordToggle from "../../Components/FormField/PasswordToggle";
// import CheckableButton from "../../Components/CheckableButton/CheckableButton"
// import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import Auth from "../../Auth/Auth";
import { API } from "../../API";

import { connect } from "react-redux";
import { updateToRoot } from "../../redux/college/college.actions";
import LoginToggle from "../Signup-Login/LoginToggle";
import { updateSimpleQualification } from "../../redux/homePage/homePage.actions";

const LoginAsInstitution = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { user, college } = props;
  // const URL = PORT
  // const linkedinAPI = `${PORT}/auth/linkedin/login`
  // const proxyurl = "https://cors-anywhere.herokuapp.com/"

  useEffect(() => {
    const token = window.localStorage.getItem('token');
    const userID = window.localStorage.getItem('userID');
    if(token) {
      console.log("U & C: ", user, college, userID)
      if(user && college?.email) {
        Auth.logout();
      }
      else if(user && !college?.email && user._id !== userID) {
        // console.log("user !== ID")
        Auth.logout();
      }
      else if(college?.email && !user) {
        const customerID = college.customer_id || college.personnel_id
        if(customerID !== userID) {
          // console.log("college !== ID")
          Auth.logout();
        }
        else {
          // console.log("go to profile")
          props.history.push("/Profile")
        }
      }
      else if(!college?.email && !college?.personnel_email) {
        if(user) {
          // console.log("go to dashboard")
          props.history.push("/Dashboard")
        }
      }
      else if(college?.email || college?.personnel_email) {
        // console.log("go to profile")
        props.history.push("/Profile")
      }
    }
    if (props.location.state) {
      if (props.location.state.error) {
        notify.show(props.location.state.error, "success", 3000);
      }
    }
  }, []);

  const getDataOnLogin = async (user, role) => {
    let institution = {};
    let campuses = [];
    let personnel = [];
    let classes = [];

    let institution_id =
      role === "customer" ? user?.institution_id : user?.institution;

    institution = await API.getInstitutionData({ id: institution_id });
    institution = institution.data;
    const promises = [
      (async () => {
        return await API.getMultipleCampusById(institution.campuses);
      })(),
      (async () => {
        return await API.getPersonnelByInstId(institution._id);
      })(),
      (async () => {
        return await API.getSimpleQualification();
      })(),
    ]

    const [campusRes, personnelRes, quaRes] = await Promise.all(promises)
    campuses = campusRes.data.reverse();
    personnel = personnelRes.data.reverse();
    const simpleQualifications = quaRes.data?.data || []
    classes = await API.getClassesByCampuses(
      role === "customer" || role === "personnel" ? institution.campuses : user.campuses
    );
    classes = classes.data.reverse();
    props.updateToRoot(user, role, institution, campuses, personnel, classes);
    props.updateSimpleQualification(simpleQualifications)

  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // if remember me checked the expire time would be three month
    // else 1 day
    // if (window.localStorage.getItem('userType') === 'null') {
      // notify.show("Please select to log in as Teacher or Institution/Provider.")
      // return;
    // }
    await API.institutionLogin({
      user: {
        email,
        password,
      },
    })
      .then(async (res) => {
        // console.log(res)
        switch (res.data.msg) {
          case "User is not verified":
            notify.show(
              `Look for an email from ${email} and verify your account.`
            );
            break;
          case "User does not exist":
          case "Invalid Credentials":
            notify.show("Invalid email address or password.");
            break;
          case "instituition-existent-email":
            notify.show(
              <React.Fragment>
                {"Email in use. Please sign in via "}
                <a href="/Login">
                  <b>teacher page</b>.
                </a>
              </React.Fragment>
            );
            break;
        }
        switch (res.data.reason) {
          case "non-existent-user":
            console.log('non-existent-user res.data', res.data);
            notify.show(
              <React.Fragment>
                {res.data.msg}
                <a href="/RegisterCollege">
                  <b>register</b>.
                </a>
              </React.Fragment>
            );
            break;
          case "customer-existent-email":
            console.log('customer-existent-email res.data', res.data);
            notify.show(
              <React.Fragment>
                {res.data.msg}
                <a href="/LoginAsInstitution">
                  <b>login screen</b>.
                </a>
              </React.Fragment>
            );
            break;
          case "personnel-existent-email":
            console.log('personnel-existent-email res.data', res.data);
            notify.show(
              <React.Fragment>
                {res.data.msg}
                <a href="/LoginAsInstitution">
                  <b>login screen</b>.
                </a>
              </React.Fragment>
            );
            break;
          case "user-archived":
            notify.show(
              <React.Fragment>
                {res.data.msg}
              </React.Fragment>
            );
            break;
          case "user-existent-email":
            console.log('user-existent-email res.data', res.data);
            notify.show(
              <React.Fragment>
                {res.data.msg}
                <a href="/Login">
                  <b>login screen</b>.
                </a>
              </React.Fragment>
            );
            window.localStorage.setItem('userType', 'teacherLogin');
            setTimeout(() => {
              window.location.href = '/Login'
            }, 3000)
            break;
          default:
            const { user, role } = res.data;
            // console.log("user", user)
            let userType = window.localStorage.getItem('userType');
            const originalPath = window.localStorage.getItem('path')
            const teacherId = window.localStorage.getItem("teacher_id");
            window.localStorage.clear();
            window.localStorage.setItem('userType', userType);
            window.localStorage.setItem("token", res.data.token);
            window.localStorage.setItem("userID", user?.customer_id);
            let path = "/LoginAsInstitution";
            Auth.login();

            await getDataOnLogin(user, role);
            if (teacherId) {
              window.location = `/ViewCalendar/?teacher_id=${teacherId}`
            }
            path =
              role === "customer" ? "/CollegeDashboard" : "/PersonnelDashboard";
            if(!originalPath?.includes("#")) {
              props.history.push(path);
            }
            else {
              props.history.push(originalPath || path);
            }
            
        }
      })
      .catch((err) => {
        console.log(err.response || err);
        if (err.response) {
          console.log(err.response.data);
          switch (err.response.data.error) {
            case "User is not verified":
              notify.show(
                "You must verify your email address before logging in."
              );
              break;
            case "User does not exist":
            case "Invalid Credentials":
              notify.show("Invalid email address or password.");
              break;
            case "instituition-existent-email":
              notify.show(
                <React.Fragment>
                  {"Email in use. Please sign in via "}
                  <a href="/Login">
                    <b>teacher page</b>.
                  </a>
                </React.Fragment>
              );
              break;
            default:
              notify.show("Error logging in. Please try again.");
              break;
          }
        } else {
          notify.show("Server error. Please try again later.");
        }
      });
  };

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const responseFromGoogle = async (response) => {
    const { history } = props;

    if (response.profileObj) {
      await API.loginCustomerPersonnelGoogle(response.tokenId)
        .then(async (res) => {
          console.dir(res);
          let user, role;
          if(res.data?.reason) {
            return notify.show(
              <React.Fragment>
                {res.data.msg}
                {
                  res.data.reason !== "user-archived"
                  && (
                    <a href="/Login">
                      <b>login screen</b>.
                    </a>
                    )
                }
              </React.Fragment>
            );
          }
          if (res.data.customer) {
            user = res.data.customer;
            role = "customer";
          } else {
            user = res.data.personnel;
            role = "personnel";
          }
          let path = "/LoginAsInstitution";
          if (user.email_verification_status) {
            Auth.login();
            await getDataOnLogin(user, role);
            path = "/CollegeDashboard";
            history.push(path);
            let userType = window.localStorage.getItem('userType');
            window.localStorage.clear();
            window.localStorage.setItem('userType', userType);
            window.localStorage.setItem("token", res.data.token);
            window.localStorage.setItem("userID", user._id);
          } else {
            // console.log(user)
            if (res.data.customer) {
              path = `/confirmcollege?id=${user._id}`;
            } else {
              path = `/confirmpersonnel?id=${user._id}`;
            }
            window.location.href = path;
          }
        })
        .catch((err) => {
          console.dir(err);
          if (err.response?.data) {
            if(err.response?.data?.reason === "no-inst-account") {
              return notify.show(
                <React.Fragment>
                  {err.response.data.msg}
                  <a href="/RegisterCollege">
                    <b>signup screen</b>.
                  </a>
                </React.Fragment>
              )
            }
            
            notify.show(err.response.data.token, "error");
          }
          console.log(err.message);
        });
    } else {
      console.log("Fail");
      console.log(response);
    }
  };

  return (
    <>
      <script src="https://accounts.google.com/gsi/client" async defer></script>
      <SignupContainer
        heading="Log in as"
        onSubmit={handleSubmit}
        toggle={
          <div className="row justify-content-center login-toggle-container">
            <LoginToggle />
          </div>
        }
        google={
          <GoogleDivider
            onSuccess={responseFromGoogle}
            onFailure={responseFromGoogle}
            buttonText="Log in with Google"
          />
        }
      >
        {/* register with email & password form */}
        <div className="center-form">
          <FormField
            label="Email Address"
            type="email"
            id="email"
            placeholder="Enter Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            icon="email"
            autoFocus
            required
          />

          <FormField
            id="password"
            label="Password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter Your Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            icon="lock"
            required
          >
            <PasswordToggle onClick={togglePassword} />
          </FormField>
        </div>

        {/* large screen */}
        <div className="row qualification-footer small-screen-disappear justify-content-center">
          <div className="mb-3">
            <br />
            <ConfirmButton type="submit" className="signup-button">
              Submit
            </ConfirmButton>
          </div>
        </div>

        {/* small screen */}
        <div className="row qualification-footer small-screen-appear d-none">
          <div className="col-md-7 mb-3 sign-up-footer">
            <ConfirmButton type="submit">Submit</ConfirmButton>
          </div>
        </div>

        {/* link for if the user has an account already */}
        <div className="footer">
          <Link
            className="row qualification-footer justify-content-center"
            to="/resetSendEmail"
          >
            <br />
            Forgot Password?
          </Link>
          <LinkToCreateAccount />
        </div>
      </SignupContainer>
    </>
  );
};

function mapStateToProps(state) {
  return {
    user: state.user?.user,
    college: state.college?.user
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateToRoot: (...data) => dispatch(updateToRoot(...data)),
  updateSimpleQualification: (data) => dispatch(updateSimpleQualification(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginAsInstitution);
